// Generated by ReScript, PLEASE EDIT WITH CARE

import * as RR from "common/src/RR.bs.js";
import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as TraitOverview from "./TraitOverview.bs.js";
import * as InContextOverview from "./InContextOverview.bs.js";

function InContextTraitOverview(Props) {
  var initialRank = Props.rank;
  var traitId = Props.traitId;
  var onClose = Props.onClose;
  var match = React.useState(function () {
        return null;
      });
  var setScrollRef = match[1];
  var set = TftSet.use(undefined);
  var match$1 = React.useState(function () {
        return initialRank;
      });
  var setRank = match$1[1];
  var traitsT = Translation.useT(/* Traits */2);
  RR.useIsoLayoutEffect2((function (param) {
          Curry._1(setRank, (function (param) {
                  return initialRank;
                }));
          
        }), [
        traitId,
        initialRank
      ]);
  var maxRank = Sd.traitRankCounts(traitId, set).length;
  var rank = Caml.caml_int_min(match$1[0], maxRank);
  var aperture = ApertureCtx.useValue(undefined);
  return React.createElement(InContextOverview.make, {
              header: React.createElement("div", {
                    className: "flex items-center gap-2"
                  }, Belt_Array.mapWithIndex(Sd.traitRankCounts(traitId, set), (function (idx, param) {
                          var currRank = idx + 1 | 0;
                          return React.createElement("div", {
                                      className: CssJs.merge([
                                            CssJs.style([CssJs.opacity(rank === currRank ? 1 : 0.3)]),
                                            "cursor-pointer"
                                          ]),
                                      onClick: (function (param) {
                                          return Curry._1(setRank, (function (param) {
                                                        return currRank;
                                                      }));
                                        })
                                    }, React.createElement(TraitTooltip.make, {
                                          trait: traitId,
                                          rank: currRank,
                                          children: React.createElement(TraitImage.PlainIcon2.make, {
                                                traitId: traitId,
                                                rank: currRank,
                                                size: 32
                                              })
                                        }));
                        })), React.createElement("div", {
                        className: "pl-3 font-medium text-xl"
                      }, String(Sd.traitRankUnitCount(traitId, rank, set)) + " " + traitsT(traitId))),
              onExpand: {
                TAG: /* Stats */0,
                _0: {
                  TAG: /* Trait */5,
                  trait: traitId,
                  rank: rank,
                  aperture: aperture
                }
              },
              children: React.createElement("div", {
                    className: "p-4 pt-16"
                  }, React.createElement(TraitOverview.make, {
                        inContext: true,
                        traitId: traitId,
                        rank: rank,
                        scrollRef: match[0],
                        key: traitId + String(rank)
                      })),
              onClose: onClose,
              setScrollRef: (function (ref) {
                  return Curry._1(setScrollRef, (function (param) {
                                return ref;
                              }));
                })
            });
}

var make = InContextTraitOverview;

export {
  make ,
  
}
/* RR Not a pure module */
